module.exports = __webpack_public_path__ + "img/loginLogo2.382e520a.png";